import axios from 'axios';
import Vue from 'vue'
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Toast } from "vant";

let http = axios.create({
  baseURL: process.env.ApiRoot,
  // withCredentials: true,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [function(data) {
    let newData = '';
    for (let k in data) {
      if (data.hasOwnProperty(k) === true) {
        newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
      }
    }
    return newData;
  }]
});


http.interceptors.request.use(
  config => {
    NProgress.start();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  res => {
    NProgress.done();
    //请求成功
    if (res.status === 200) {
      let {
        data
      } = res;
      //接口成功
      if (data.successed) {
        return Promise.resolve(data);
      } else {
        return Promise.reject(data);
      }
    } else {
      return Promise.reject(res);
    }
  },
  error => {
    NProgress.done();
    return Promise.reject(error.response);
  }
)

export default http



// WEBPACK FOOTER //
// ./src/utils/request.js